import { Product } from '@/types/product';

export const indoorProducts: Product[] = [
  {
    id: 'air19',
    name: 'Air 19',
    size: '19.5インチ / FHD',
    description: 'コンパクトサイズで多様な設置に対応',
    image: '/org/product/indoor/Air/Air19fig.png',
    specs: {
      brightness: '450nits',
      weight: '3.85kg',
      thickness: '13.5mm厚',
    },
    category: 'indoor',
    detailedSpecs: [
      ['画面サイズ', '19.5インチ'],
      ['解像度', '1920 x 1080 (FHD)'],
      ['輝度', '450 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '3.85kg'],
      ['厚さ', '13.5mm'],
      ['電源', 'DC 24V'],
      ['消費電力', '35W (標準) / 45W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '100 x 100mm'],
    ],
    features: [
      {
        icon: '📱',
        title: 'コンパクトサイズ',
        description: '19.5インチのコンパクトサイズで、狭いスペースにも設置可能',
      },
      {
        icon: '💡',
        title: '高輝度表示',
        description: '450nitsの高輝度で、明るい場所でも鮮明な表示',
      },
      {
        icon: '⚡',
        title: '省電力設計',
        description: '効率的な省電力設計で、運用コストを削減',
      },
    ],
  },
  {
    id: 'wicanvas3',
    name: 'WiCanvas 3',
    size: '32インチ / FHD',
    description: '標準的なサイズで幅広い用途に対応',
    image: '/org/product/indoor/WiCanvas3/WiCanvas3_32_fig.png',
    specs: {
      brightness: '450nits',
      weight: '5.2kg',
      thickness: '13.3mm厚',
    },
    category: 'indoor',
    detailedSpecs: [
      ['画面サイズ', '32インチ'],
      ['解像度', '1920 x 1080 (FHD)'],
      ['輝度', '450 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '5.2kg'],
      ['厚さ', '13.3mm'],
      ['電源', 'DC 24V'],
      ['消費電力', '55W (標準) / 70W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '200 x 200mm'],
    ],
    features: [
      {
        icon: '🎯',
        title: 'スタンダードサイズ',
        description: '32インチの最適なサイズで、様々なシーンに対応',
      },
      {
        icon: '🔧',
        title: '簡単設置',
        description: 'ブラケット取り付けで簡単設置、配線工事不要',
      },
      {
        icon: '📊',
        title: '多彩なコンテンツ',
        description: '動画、画像、PDFなど多様なフォーマットに対応',
      },
    ],
  },
  {
    id: 'air43',
    name: 'Air 43',
    size: '43インチ / 4K UHD',
    description: '高精細4K表示対応モデル',
    image: '/org/product/indoor/Air/Air43fig.png',
    specs: {
      brightness: '500nits',
      weight: '9.3kg',
      thickness: '16.3mm厚',
    },
    category: 'indoor',
    detailedSpecs: [
      ['画面サイズ', '43インチ'],
      ['解像度', '3840 x 2160 (4K UHD)'],
      ['輝度', '500 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '9.3kg'],
      ['厚さ', '16.3mm'],
      ['電源', 'DC 24V'],
      ['消費電力', '95W (標準) / 120W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '200 x 200mm'],
    ],
    features: [
      {
        icon: '🎬',
        title: '4K高画質',
        description: '3840×2160の4K解像度で細部まで鮮明に表示',
      },
      {
        icon: '✨',
        title: '高輝度500nits',
        description: '明るい環境下でも優れた視認性を実現',
      },
      {
        icon: '📐',
        title: '薄型軽量',
        description: '16.3mm厚、9.3kgで壁掛け設置も簡単',
      },
    ],
  },
  {
    id: 'air55',
    name: 'Air 55 QLED',
    size: '55インチ / 4K QLED',
    description: 'QLED搭載プレミアムモデル',
    image: '/org/product/indoor/Air/Air55fig.png',
    specs: {
      brightness: '450nits',
      weight: '14.5kg',
      thickness: '16.8mm厚',
    },
    category: 'indoor',
    detailedSpecs: [
      ['画面サイズ', '55インチ'],
      ['解像度', '3840 x 2160 (4K UHD)'],
      ['パネルタイプ', 'QLED (量子ドット)'],
      ['輝度', '450 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '14.5kg'],
      ['厚さ', '16.8mm'],
      ['電源', 'DC 24V'],
      ['消費電力', '130W (標準) / 160W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '400 x 400mm'],
    ],
    features: [
      {
        icon: '🌈',
        title: 'QLED技術',
        description: '量子ドット技術で広色域と鮮やかな色彩表現を実現',
      },
      {
        icon: '🎨',
        title: '10億色表示',
        description: '10bitカラーで滑らかで美しいグラデーション',
      },
      {
        icon: '📏',
        title: '大画面55インチ',
        description: 'インパクトのある映像表示が可能な大画面',
      },
    ],
  },
  {
    id: 'max65',
    name: 'Max 65',
    size: '65インチ / 4K UHD',
    description: '大画面インパクトモデル',
    image: '/org/product/indoor/Max/Max65fig.png',
    specs: {
      brightness: '500nits',
      weight: '28.3kg',
      thickness: '19.7mm厚',
    },
    category: 'indoor',
    detailedSpecs: [
      ['画面サイズ', '65インチ'],
      ['解像度', '3840 x 2160 (4K UHD)'],
      ['輝度', '500 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '28.3kg'],
      ['厚さ', '19.7mm'],
      ['電源', 'AC 100-240V'],
      ['消費電力', '180W (標準) / 220W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '400 x 400mm'],
    ],
    features: [
      {
        icon: '🖥️',
        title: '大画面65インチ',
        description: '圧倒的な存在感でインパクトのある映像表示',
      },
      {
        icon: '💎',
        title: '4K高画質',
        description: '大画面でも鮮明で美しい映像を表示',
      },
      {
        icon: '🎯',
        title: '業務用途対応',
        description: 'ショールーム、展示会など業務用途に最適',
      },
    ],
  },
  {
    id: 'max75',
    name: 'Max 75 QLED',
    size: '75インチ / 4K QLED',
    description: '最大サイズQLEDモデル',
    image: '/org/product/indoor/Max/Max75fig.png',
    specs: {
      brightness: '450nits',
      weight: '45kg',
      thickness: '30mm厚',
    },
    category: 'indoor',
    detailedSpecs: [
      ['画面サイズ', '75インチ'],
      ['解像度', '3840 x 2160 (4K UHD)'],
      ['パネルタイプ', 'QLED (量子ドット)'],
      ['輝度', '450 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '45kg'],
      ['厚さ', '30mm'],
      ['電源', 'AC 100-240V'],
      ['消費電力', '220W (標準) / 280W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '600 x 400mm'],
    ],
    features: [
      {
        icon: '👑',
        title: '最大75インチ',
        description: 'シリーズ最大の圧倒的大画面で最高のインパクト',
      },
      {
        icon: '🌟',
        title: 'QLED最上位',
        description: '量子ドット技術による最高クラスの色彩表現',
      },
      {
        icon: '🎭',
        title: 'プロ仕様',
        description: '大型施設や高級店舗など最高品質が求められる場所に',
      },
    ],
  },
];

export const outdoorProducts: Product[] = [
  {
    id: 'o49-2500',
    name: 'O49-2500',
    size: '49インチ / FHD Outdoor',
    description: '屋外対応高輝度ディスプレイ',
    image: '/org/product/outdoor/O49_2500_fig.png',
    specs: {
      brightness: '2500nits',
      weight: '69.8kg',
      thickness: 'IP56',
    },
    category: 'outdoor',
    detailedSpecs: [
      ['画面サイズ', '49インチ'],
      ['解像度', '1920 x 1080 (FHD)'],
      ['輝度', '2500 cd/m² (nits)'],
      ['コントラスト比', '4000:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '69.8kg'],
      ['防水防塵', 'IP56'],
      ['電源', 'AC 100-240V'],
      ['消費電力', '450W (標準) / 550W (最大)'],
      ['動作温度', '-30°C ~ 50°C'],
      ['保管温度', '-40°C ~ 60°C'],
      ['耐久性', '24時間連続稼働対応'],
      ['VESA規格', '400 x 400mm'],
    ],
    features: [
      {
        icon: '☀️',
        title: '超高輝度2500nits',
        description: '直射日光下でも鮮明な映像表示を実現',
      },
      {
        icon: '🛡️',
        title: 'IP56防水防塵',
        description: '雨や埃から本体を保護、過酷な屋外環境でも安心',
      },
      {
        icon: '🌡️',
        title: '広温度範囲',
        description: '-30°C～50°C対応、あらゆる気候条件で稼働',
      },
    ],
  },
];

export const squareProducts: Product[] = [
  {
    id: 'cube6',
    name: 'Cube 6',
    size: '33.2インチ / 1920×1920',
    description: '正方形ディスプレイ',
    image: '/org/product/indoor/Cube/cube6fig.png',
    specs: {
      brightness: '500nits',
      weight: '10kg',
      thickness: '16mm厚',
    },
    category: 'square',
    detailedSpecs: [
      ['画面サイズ', '33.2インチ (対角)'],
      ['解像度', '1920 x 1920 (正方形)'],
      ['アスペクト比', '1:1 (正方形)'],
      ['輝度', '500 cd/m² (nits)'],
      ['コントラスト比', '1200:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '10kg'],
      ['厚さ', '16mm'],
      ['電源', 'DC 24V'],
      ['消費電力', '75W (標準) / 95W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '200 x 200mm'],
    ],
    features: [
      {
        icon: '⬛',
        title: '1:1正方形',
        description: '1920×1920ピクセルのユニークな正方形ディスプレイ',
      },
      {
        icon: '🎨',
        title: 'アート表示',
        description: 'アート作品やSNSコンテンツの表示に最適',
      },
      {
        icon: '🔄',
        title: '自由な設置',
        description: '縦横の区別がなく設置の自由度が高い',
      },
    ],
  },
  {
    id: 'cube8',
    name: 'Cube 8',
    size: '44.9インチ / 1280×1280',
    description: '大型正方形ディスプレイ',
    image: '/org/product/indoor/Cube/cube8fig.png',
    specs: {
      brightness: '500nits',
      weight: '13kg',
      thickness: '18.7mm厚',
    },
    category: 'square',
    detailedSpecs: [
      ['画面サイズ', '44.9インチ (対角)'],
      ['解像度', '1280 x 1280 (正方形)'],
      ['アスペクト比', '1:1 (正方形)'],
      ['輝度', '500 cd/m² (nits)'],
      ['コントラスト比', '1200:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['重量', '13kg'],
      ['厚さ', '18.7mm'],
      ['電源', 'DC 24V'],
      ['消費電力', '110W (標準) / 135W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
      ['VESA規格', '400 x 400mm'],
    ],
    features: [
      {
        icon: '📐',
        title: '大型正方形',
        description: '44.9インチの大型キャンバスでインパクトのある表現',
      },
      {
        icon: '🖼️',
        title: '展示最適',
        description: 'ギャラリー、美術館、展示会に最適なフォーマット',
      },
      {
        icon: '🏢',
        title: '空間演出',
        description: '個性的なフォーマットで人目を引く空間を演出',
      },
    ],
  },
];

export const accessories: Product[] = [
  {
    id: 'wibox',
    name: 'WiBox',
    size: 'STB / セットトップボックス',
    description: '既存ディスプレイをワイヤレス化',
    image: '/org/product/WiBox/WiBox_fig.png',
    specs: {
      brightness: '4K対応',
      weight: '0.5kg',
      thickness: '24W',
    },
    category: 'accessories',
    detailedSpecs: [
      ['製品タイプ', 'セットトップボックス (STB)'],
      ['対応解像度', '4K UHD (3840 x 2160)'],
      ['入力端子', 'HDMI 2.0'],
      ['出力', 'ワイヤレス伝送'],
      ['ワイヤレス規格', 'Wi-Fi 6 (802.11ax)'],
      ['対応OS', 'Windows / macOS / Android / iOS'],
      ['重量', '0.5kg'],
      ['サイズ', '150 x 100 x 30mm'],
      ['電源', 'AC 100-240V / DC 12V'],
      ['消費電力', '24W'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
    ],
    features: [
      {
        icon: '🔄',
        title: 'ワイヤレス化',
        description: '既存ディスプレイに接続するだけで簡単ワイヤレス化',
      },
      {
        icon: '📡',
        title: '4K対応',
        description: '4K UHD解像度の高画質映像をワイヤレス伝送',
      },
      {
        icon: '💻',
        title: 'マルチデバイス',
        description: 'PC、スマホ、タブレットなど様々なデバイスに対応',
      },
    ],
  },
  {
    id: 'kiosk43',
    name: 'Kiosk 43',
    size: '43インチ / スタンド一体型',
    description: '自立型キオスクディスプレイ',
    image: '/org/product/indoor/Kiosk/KIOSK43fig.png',
    specs: {
      brightness: '4K UHD',
      weight: '48.1kg',
      thickness: 'スピーカー内蔵',
    },
    category: 'accessories',
    detailedSpecs: [
      ['画面サイズ', '43インチ'],
      ['解像度', '3840 x 2160 (4K UHD)'],
      ['輝度', '500 cd/m² (nits)'],
      ['コントラスト比', '1400:1'],
      ['視野角', '178°(H) / 178°(V)'],
      ['表示色', '1.07B (10bit)'],
      ['スタンドタイプ', '自立型フロアスタンド'],
      ['スピーカー', '内蔵ステレオスピーカー (10W x 2)'],
      ['重量', '48.1kg (スタンド込み)'],
      ['高さ', '約1.5m (床から画面中央)'],
      ['電源', 'AC 100-240V'],
      ['消費電力', '120W (標準) / 150W (最大)'],
      ['動作温度', '0°C ~ 40°C'],
      ['保管温度', '-20°C ~ 60°C'],
    ],
    features: [
      {
        icon: '🏢',
        title: 'スタンド一体型',
        description: '壁掛け工事不要で設置場所を選ばず簡単設置',
      },
      {
        icon: '🔊',
        title: 'スピーカー内蔵',
        description: 'ステレオスピーカー内蔵で外部スピーカー不要',
      },
      {
        icon: '🎯',
        title: 'キオスク用途',
        description: '店舗案内、展示会、イベント受付など多用途対応',
      },
    ],
  },
];

export const allProducts = {
  indoor: indoorProducts,
  outdoor: outdoorProducts,
  square: squareProducts,
  accessories: accessories,
};
